import { computed } from '@vue/composition-api'
import { useSpeechInputStore } from '@/pinia/speechInput'

export function useSpeechRecognition() {
  const store = useSpeechInputStore()

  const isSupported = computed(() => store.isSupported)

  async function withSpeech(onResult) {
    if (!isSupported.value) return
    const text = await store.requestSpeech()
    if (text && onResult) {
      onResult(text)
    }
  }

  return { isSupported, withSpeech }
}
